/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class CalendarRepository extends repositories.BaseRepository {

    constructor() 
    {
        super({
            creation: new models.ProductCalendar({ id: "" }), // id empty so it's not created in db 
            zoom : new models.Zoom(),
        });

    }

    get calendar()
    {
        return this.creation;
    }


    initData(data)
    {
        super.initData(data);

        this.calendar.init(data.creation, {"CreationElement" : "ProductCalendarPage"});
        
        this.creation.creationOptions = data.creationOptions;
    }
   


});
